/** @format */
import lang_route from './lang_route.json';
import lang_common from './lang_common.json';
import lang_header from './lang_header.json';
import lang_footer from './lang_footer.json';
import lang_onboarding from './lang_onboarding.json';
import lang_registration from './lang_registration.json';

const swedish = {
  lang_route,
  lang_common,
  lang_header,
  lang_footer,
  lang_onboarding,
  lang_registration
};

export default swedish;
